import * as React from 'react';
import { FormContext, FormStateV3 } from '../../../../../commonv3/states/form/FormStateV3';
import { CancelRequest } from '../../../../apis/eventReservations';
import { StringValidators } from '../../../../../commonv3/states/form/validators';
import { computed } from 'mobx';
import { SingleSelectWithFreeAnswerFieldState } from '../../../../../commonv3/states/form/SingleSelectWithFreeAnswerFieldState';

type CancelFormSchema = {
    cancel_reason: SingleSelectWithFreeAnswerFieldState;
};

export class CancelFormState extends FormStateV3<CancelRequest, CancelFormSchema> {
    constructor() {
        super({
            cancel_reason: new SingleSelectWithFreeAnswerFieldState([StringValidators.required()]),
        });
    }

    init() {
        this._init('cancellation_request', new FormContext(), { cancel_reason: null });
    }

    @computed
    get reasonOptions() {
        return [
            '参加のモチベーションが減少した',
            '他の方法で学習することした',
            '参加に対して不安な気持ちがあった',
            '参加日程の都合がつかなくなった',
        ];
    }
}
